
import { BASE_URL } from "../../../helpers/config";
import { showToast, showAlert } from "../../../utils/helpers/ShowToast";
import authorizedAxios from "../../../helpers/authorizedAxios";
export const SET_DISTRICTS = "SET_DISTRICTS";
export const SET_DISTRICTS_LOADING = "SET_DISTRICTS_LOADING";
export const SET_DISTRICTS_ERROR = "SET_DISTRICTS_ERROR";

export const fetchDistricts = (limit = 100, page = 1, search = "", city_id = "") => {
  return async (dispatch) => {
    dispatch({ type: SET_DISTRICTS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/districts", {
        params: { limit, page, search, city_id }
      });

      if (response.status === 200 || response.status === 201) {
        dispatch({
          type: SET_DISTRICTS,
          data: response?.data?.data
        });
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_DISTRICTS_ERROR,
        error: error?.response?.data || "Terjadi kesalahan saat mengambil data."
      });
    } finally {
      dispatch({ type: SET_DISTRICTS_LOADING, status: false });
    }
  };
};

export const addDistrict = (data) => {
  return async (dispatch) => {
    dispatch({ type: SET_DISTRICTS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.post(`${BASE_URL}/districts`, data), {
        loading: "Menyimpan data...",
        success: "Data Kecamatan berhasil ditambahkan!",
        error: (err) => err?.response?.data?.message || "Gagal menyimpan data Kecamatan!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data Kecamatan berhasil ditambahkan!"
        });
        dispatch(fetchDistricts());
        return true;
      }
      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_DISTRICTS_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
      return false;
    } finally {
      dispatch({ type: SET_DISTRICTS_LOADING, status: false });
    }
  };
};

export const updateDistrict = (id, data) => {
  return async (dispatch) => {
    dispatch({ type: SET_DISTRICTS_LOADING, status: true });
    try {
      const response = await showToast(authorizedAxios.put(`${BASE_URL}/districts/${id}`, data), {
        loading: "Mengupdate data...",
        success: "Data Kecamatan berhasil diupdate!",
        error: (err) => err?.response?.data?.message || "Gagal mengupdate data Kecamatan!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data Kecamatan berhasil diupdate!"
        });
        dispatch(fetchDistricts());
        return true;
      }
      return false;
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_DISTRICTS_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
      return false;
    } finally {
      dispatch({ type: SET_DISTRICTS_LOADING, status: false });
    }
  };
};

export const deleteDistrict = (id) => {
  return async (dispatch) => {
    dispatch({ type: SET_DISTRICTS_LOADING, status: true });

    try {
      const response = await showToast(authorizedAxios.delete(`${BASE_URL}/districts/${id}`), {
        loading: "Menghapus data...",
        success: "Data Kecamatan berhasil dihapus!",
        error: (err) => err?.response?.data?.message || "Gagal menghapus data!"
      });
      if (response.status === 200 || response.status === 201) {
        showAlert({
          type: "success",
          message: "Data Kecamatan berhasil dihapus!"
        });
        dispatch(fetchDistricts());
      }
    } catch (error) {
      console.error("error", error);
      dispatch({
        type: SET_DISTRICTS_ERROR,
        error: error?.message || "Terjadi kesalahan."
      });
    } finally {
      dispatch({ type: SET_DISTRICTS_LOADING, status: false });
    }
  };
};
